// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"az_yQb","containerRightFrame":"az_zQb","outerContainer":"az_AQb","table":"az_BQb","tableHeadCellSticky":"az_CQb","tableRow":"az_DQb","tableCell":"az_EQb"};